import { render, staticRenderFns } from "./tppApps.vue?vue&type=template&id=6c19084b&scoped=true&"
import script from "./tppApps.vue?vue&type=script&lang=js&"
export * from "./tppApps.vue?vue&type=script&lang=js&"
import style0 from "./tppApps.vue?vue&type=style&index=0&id=6c19084b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19084b",
  null
  
)

export default component.exports